import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataFetcherService } from '../../services/data-fetcher/data-fetcher.service';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  workspaces: any[] = [];  // Array to store the list of workspaces
  workspaceAccess: any[] = []; //Array to store the list of workspaceAccesses
  isLoading = false;  // Controls the loading animation
  resultMessage: string | null = null; // Stores success/failure message

  
  constructor(private dataFetcher: DataFetcherService) {}

  ngOnInit() {
    // Fetch the workspaces data when the component initializes
    this.dataFetcher.getWorkspacesData().subscribe(
      (data: any) => {
        // Extract the 'workspaces' array from the data object
        this.workspaces = data.workspaces || [];  // Fallback to an empty array if 'workspaces' is undefined
      },
      (error) => {
        console.error('Error fetching workspaces data', error);
      }
    );
    this.sortWorkspaces();
  }

  // Method to toggle the favorite status of a workspace
  toggleFavorite(workspace: any) {
    workspace.fav = !workspace.fav;
    this.dataFetcher.updateFavWorkspace(workspace.id, workspace.fav)
    this.sortWorkspaces()
  }

// Sorting method to ensure favorites appear first
sortWorkspaces() {
  this.workspaces.sort((a, b) => {
    if (a.fav === b.fav) return 0;
    return a.fav ? -1 : 1;
  });
}

// Return sorted workspaces for display
sortedWorkspaces() {
  return [...this.workspaces].sort((a, b) => {
    if (a.fav === b.fav) return 0;
    return a.fav ? -1 : 1;
  });
}

onButtonClick(): void {
  console.log("Button clicked");

  // Start loading animation
  this.isLoading = true;
  this.resultMessage = null; // Clear any previous messages

  this.dataFetcher.refreshTenant().subscribe({
    next: (response) => {
      console.log("Tenant refreshed:", response);

      // Stop loading and show result message
      this.isLoading = false;
      this.resultMessage = response.result ? "Tenant refreshed successfully!" : "Failed to refresh tenant.";

      // Refresh screen after 2 seconds
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    },
    error: (error) => {
      console.error("Error refreshing tenant:", error);

      // Stop loading and show error message
      this.isLoading = false;
      this.resultMessage = "Error refreshing tenant.";

      // Refresh screen after 2 seconds
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  });
}



onShowWorkspaceAccess(workspaceId: string): void {
  // Fetch the workspaceAccesses data when the button is pressed
  this.dataFetcher.getWorkspaceAccessByWorkspaceId(workspaceId).subscribe(
    (data: any) => {
      // Extract the 'workspaceAccesses' array from the data object
      this.workspaceAccess = data.workspaceAccesses || [];  // Fallback to an empty array if 'workspaceAccesses' is undefined
    },
    (error) => {
      console.error('Error fetching workspaceAccesses data', error);
    }
  );
}
}
